<template>
  <div id="couponbox">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$fanyi('我的券包')" name="我的卷包">
        <div v-loading="loanding">
          <div class="mycoupon" v-if="!Nodata">
            <!-- 代金券/优惠劵-->
            <div class="couponitem" v-for="(item, index) in couponList" :key="index">
              <div class="header">
                <div v-if="item.type == 10" class="coupon">{{ $fanyi('优惠券') }}</div>
                <div v-if="item.type == 30" class="Voucher">{{ $fanyi('代金券') }}</div>
                <div class="no">
                  No. {{ item.number }}
                </div>
              </div>

              <div class="content">
                <h1>{{ item.title }} </h1>
                <img v-if="item.type == 10" src="../../../../assets/newassets/coupon/Coupons.svg" alt="">
                <img v-if="item.type == 30" src="../../../../assets/newassets/coupon/Vouchers.svg" alt="">
              </div>
              <div class="footer">
                <p class="Orderamount">
                  <span v-if="item.type == 30 && item.status == 10">{{ $fanyi('订单金额') }} > ₴{{ item.restrictions
                    }}</span>
                </p>
                <p>
                  {{ $fanyi('有效期') }}:<br />{{ item.free_datetime_start }}--
                  {{ item.free_datetime_end }}
                </p>
              </div>
            </div>


          </div>

          <div class="Nodata" v-if="Nodata">

            <div class="NodataImg">
              <img src="../../../../assets/defaulticon/coupon.svg" alt="">
            </div>

            <div class="NodataText">

              {{ $fanyi('暂无可用优惠券') }}
            </div>

          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$fanyi('使用记录')" name="使用记录">
        <div class="Usagerecord">
          <div class="search">
            <el-select v-model="datas.type" :placeholder="$fanyi('请选择')">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div class="myInput">
              <i class="el-icon-search"></i>
              <input type="text" v-model="datas.keywords" :placeholder="$fanyi('请输入内容')" />
            </div>
            <el-button type="primary" @click="couponRecord">{{
              $fanyi('搜索')
            }}</el-button>
          </div>
          <div class="table" v-loading="loanding">
            <el-table :data="tableData" style="width: 100%" border :header-cell-style="{
              'background': '#F5F5F5', 'height': '50px', 'font-size': '14px',
              'border': 'none',
              'color': '#121212',
              'font-weight': '500'
            }" :cell-style="{ 'text-align': 'center', 'color': '#121212', 'font-size': '14px', 'height': '60px', }">
              <el-table-column prop="rowNumber" label="NO" align="center" width="50">
              </el-table-column>
              <el-table-column prop="number" :label="$fanyi('优惠券/代金券编码')" align="center" width="170">
              </el-table-column>
              <el-table-column prop="title" width="135" :label="$fanyi('类别')" align="center">
                <template slot-scope="scope">
                  <div>
                    {{ $fanyi(scope.row.title) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="free_kin" :label="$fanyi('额度/可使用次数')" align="center" width="130px">
              </el-table-column>
              <el-table-column prop="address" :label="$fanyi('生效时间段')" align="center" width="160px">
                <template slot-scope="scope">
                  <p>{{ scope.row.free_datetime_start }}</p>

                  <p>{{ scope.row.free_datetime_end }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="updatetime" :label="$fanyi('使用日期')" align="center" width="100px">
              </el-table-column>
              <el-table-column prop="address" :label="$fanyi('使用状态')" width="90px" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 10">
                    {{ $fanyi('待使用') }}
                  </span>
                  <span v-else-if="scope.row.status == 20">
                    {{ $fanyi('已使用') }}
                  </span>
                  <span v-else-if="scope.row.status == 30">
                    {{ $fanyi('已过期') }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="order_sn" :label="$fanyi('订单号')" align="center">
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="allpag">
            <el-pagination @current-change="handleCurrentChange" :current-page="datas.page" :page-size="10"
              :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: '我的卷包',
      couponList: [],
      datas: {
        page: 1,
        pageSize: 10,
        keywords: '',
        type: '',

      }, Nodata: false,
      options: [
        {
          label: this.$fanyi('已使用'),
          value: '已使用',
        },
        {
          label: this.$fanyi('已过期'),
          value: '已过期',
        },
      ],
      loanding: false,
      tableData: [],
      total: 0,
    }
  },
  created() {
    this.couponRecord()
    this.couponGet()
  },
  methods: {
    couponGet() {
      this.loanding = true
      this.$api.couponGet({ page: 1, pageSize: 999 }).then((res) => {

        if (res.code != 0) return this.Nodata = true
        this.loanding = false
        if (res.data.data.length == 0) {
          this.Nodata = true
        } else {
          this.Nodata = false
        }
        this.couponList = res.data.data
      })
    },

    couponRecord() {
      this.loanding = true
      this.$api.couponRecord(this.datas).then((res) => {
        this.loanding = false
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    handleCurrentChange(val) {
      this.datas.page = val
      this.couponRecord()
    },
    handleClick() { },
  },
}
</script>
<style>
.el-select-dropdown__wrap {
  margin-bottom: -12px !important;
}
</style>
<style lang="scss" scoped>
.Nodata {
  display: flex;
  align-items: center;
  height: 360px;
  padding-top: 58px;
  flex-direction: column;

  .NodataImg {
    width: 160px;
    height: 160px;

    img {
      width: 100%;
      height: 100%;
    }


    margin-bottom: 30px;
  }

  .NodataText {
    font-weight: normal;
    font-size: 24px;
    color: #121212;
    line-height: 20px;
  }

}


#couponbox {
  min-height: 600px;

  width: 1060px;
  min-height: 328px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 0px 20px;

  /deep/ .el-tabs__nav-scroll {

    padding-top: 10px;
    height: 50px;
    font-size: 16px;

    font-weight: 400;

    .el-tabs__active-bar {
      background-color: #D12A1D;

    }
  }

  /deep/ .el-tabs__nav-wrap::after {
    background: #DFDFDF;
    height: 1px;
  }

  /deep/ .el-tabs__item {
    min-width: 130px;
    text-align: center;

    &:hover {
      font-weight: 400;
      font-size: 14px;
      color: #D12A1D;
    }

    &.is-active {
      color: #D12A1D;
    }
  }

  .mycoupon {
    width: 840px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 300px;
    padding-bottom: 30px;
    background: #FFFFFF;
    padding-left: 10px;
    flex-wrap: wrap;
    padding-top: 15px;

    .couponitem {
      width: 400px;

      min-height: 360px;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.1);
      border-radius: 20px;
      padding: 30px;
      margin-bottom: 30px;

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
        margin-bottom: 35px;

        .Voucher {
          min-width: 140px;
          height: 30px;
          padding: 0px 8px;
          background: #E8EDFA;
          border-radius: 8px;
          font-weight: 500;
          font-size: 14px;
          color: #2052CE;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .coupon {
          min-width: 140px;
          height: 30px;
          padding: 0px 8px;
          background: #F2E8FB;
          border-radius: 8px;
          font-weight: 500;
          font-size: 14px;
          color: #841DD3;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .no {
          font-weight: 500;
          font-size: 14px;
          color: #121212;
          line-height: 20px;
        }
      }

      .content {
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;
        min-height: 154px;

        h1 {
          width: 100%;
          font-weight: bold;
          font-size: 40px;
          color: #121212;

          min-height: 50px;
          text-align: center;
          margin-bottom: 26px;

          overflow: hidden;
        }

        img {
          width: 36px;
          height: 36px;
        }
      }

      .footer {
        p {
          font-weight: 500;
          font-size: 14px;
          color: #121212;
          line-height: 20px;
          min-height: 20px;

          &:first-child {
            margin-bottom: 15px;
          }
        }
      }
    }
  }

  .Usagerecord {
    padding-top: 5px;

    .search {
      display: flex;
      margin-bottom: 20px;

      /deep/.el-select {
        input {
          width: 296px;
          height: 40px;
          background: #FFFFFF;
          border-radius: 12px;
          border: 1px solid #DFDFDF;
        }

        margin-right: 20px;
      }


      /deep/.myInput {
        width: 400px;
        height: 40px;
        border-radius: 12px;
        position: relative;
        display: flex;
        align-items: center;
        // overflow: hidden;
        margin-right: 20px;

        >i {
          width: 20px;
          height: 24px;
          margin: 9px 11px 9px 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #A2A2A2;
          position: absolute;
        }

        >input {
          border: 1px solid #e2e2e2;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          font-size: 14px;
          padding-left: 40px;
          padding-right: 10px;
          transition: 0.3s;

          &:focus {
            border-color: #ff730b;
          }

          &::placeholder {
            color: #9a9a9a;
          }
        }
      }

      .el-button {
        min-width: 80px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #D12A1D;
        border-radius: 12px;
      }
    }


    /deep/.el-table {
      border-radius: 12px;

      overflow: hidden;
      border-bottom: none;
      border-color: #dfdfdf;

      .el-table__cell {
        border-color: #dfdfdf !important;

      }

      tr {
        border-color: #dfdfdf;

        &:last-child {


          overflow: hidden;

          td {

            &:first-child {
              border-radius: 0 0 0px 12px;
            }

            &:last-child {
              border-radius: 0 0 12px 0px;
            }

          }
        }
      }

      .el-table__empty-block {
        border-radius: 0 0 12px 12px;
      }
    }

    /deep/.el-table__header-wrapper {


      border-bottom: 1px solid #dfdfdf;

      .cell {
        line-height: 14px;
      }

      /deep/.el-table__empty-block {
        height: 80px !important;
        border-bottom: 0.5px solid #dfdfdf;
      }
    }

    .allpag {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px 0px;

      .el-pagination {
        display: flex;
        align-items: center;
      }

      >a {
        display: inline-block;
        border: 1px solid #dcdfe6;
        height: 28px;
        // background-color: white;
        text-align: center;
        padding: 0 10px;
        font-size: 13px;
        line-height: 28px;
        border-radius: 0;
      }

      /deep/.btn-prev {
        width: 30px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #DFDFDF;
        padding: 0;
        margin-right: 15px;
        margin-left: 20px;

        .el-icon {
          font-size: 16px;
          color: #000000;
        }
      }

      /deep/.btn-next {
        width: 30px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #DFDFDF;
        padding: 0;
        margin-left: 15px;



        .el-icon {
          font-size: 16px;
          color: #000000;
        }
      }

      /deep/ .el-pagination__jump {

        .el-input {
          width: 50px;
          height: 30px;
          background: #FFFFFF;
          border-radius: 8px;
          margin-left: 5px;

          font-weight: 400;
          font-size: 14px;
          color: #000000;

          .el-input__inner {
            height: 30px;
            border-radius: 8px;
          }

        }
      }

      /* 分页被选中的页码样式 */
      /deep/ .el-pager li {
        margin: 0 5px;
        width: 30px;
        line-height: 30px;
        height: 30px;
        border-radius: 8px;
        // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

        &:hover {
          color: #D12A1D;
        }

        &.active {
          width: 30px;

          height: 30px;
          background: #D12A1D;
          line-height: 30px;
          color: #fff;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>
